import { useSearchParams } from 'react-router-dom';
import { Archive, Lock, PhoneCall } from 'lucide-react';
import { useAuthStore } from '@/store/auth.store';

const MENSAJES: Record<string, { titulo: string; descripcion: string; icono: typeof Archive }> = {
  CLINICA_ARCHIVADA: {
    titulo: 'Clínica archivada',
    descripcion:
      'Esta clínica ha sido archivada y su acceso ha sido suspendido. Si necesita consultar expedientes o transferir datos a otro sistema, contacte a soporte para solicitar acceso temporal de lectura.',
    icono: Archive,
  },
  CLINICA_ARCHIVADA_SOLO_LECTURA: {
    titulo: 'Solo lectura',
    descripcion:
      'Esta clínica está archivada. Su acceso temporal solo permite consulta de datos; no es posible registrar ni modificar información.',
    icono: Lock,
  },
  CLINICA_PURGADA_TOTAL: {
    titulo: 'Datos eliminados',
    descripcion:
      'Esta clínica ha completado el proceso de archivado definitivo. Los datos personales han sido anonimizados conforme a la LFPDPPP. Si tiene alguna duda legal, contacte al responsable de protección de datos.',
    icono: Lock,
  },
};

export default function ClinicaArchivadaPage() {
  const [params] = useSearchParams();
  const code = params.get('code') ?? 'CLINICA_ARCHIVADA';
  const info = MENSAJES[code] ?? MENSAJES['CLINICA_ARCHIVADA'];
  const Icono = info.icono;

  function handleLogout() {
    useAuthStore.getState().logout();
    window.location.href = '/login';
  }

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-slate-900 rounded-2xl border border-slate-800 p-8 text-center space-y-6">
        <div className="flex justify-center">
          <div className="w-16 h-16 rounded-full bg-amber-900/30 border border-amber-700 flex items-center justify-center">
            <Icono className="w-8 h-8 text-amber-400" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-xl font-semibold text-white">{info.titulo}</h1>
          <p className="text-slate-400 text-sm leading-relaxed">{info.descripcion}</p>
        </div>

        <div className="bg-slate-800 rounded-xl p-4 flex items-start gap-3 text-left">
          <PhoneCall className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" />
          <div className="text-xs text-slate-400 space-y-1">
            <p className="font-medium text-slate-300">¿Necesita ayuda?</p>
            <p>Contacte a soporte de la plataforma anik para solicitar acceso temporal, transferencia de expedientes o información sobre el proceso de archivado.</p>
          </div>
        </div>

        <button
          onClick={handleLogout}
          className="w-full py-2.5 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-300 text-sm font-medium transition-colors border border-slate-700"
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}
